import React from "react";
import { NavLink } from "react-router-dom";

const AppId = (cell) => {
  return (
    <NavLink to="#" className="fw-semibold link-primary">
      {cell.value ? cell.value : ""}
    </NavLink>
  );
};
const Name = (cell) => {
  return <React.Fragment>{cell.value}</React.Fragment>;
};
const Designation = (cell) => {
  return <React.Fragment>{cell.value}</React.Fragment>;
};

const Date = (cell) => {
  return <React.Fragment>{cell.value}</React.Fragment>;
};

const Contact = (cell) => {
  return <React.Fragment>{cell.value}</React.Fragment>;
};
const Type = (cell) => {
  return <React.Fragment>{cell.value}</React.Fragment>;
};

const Status = (cell) => {
  const getStatusBadge = (status) => {
    switch (status) {
      case "Success":
        return <span className="badge bg-success-subtle text-success text-uppercase">{status}</span>;
      
      case "Contacted":
        return <span className="badge bg-info-subtle text-info text-uppercase">{status}</span>;
      
      case "CallBackRequested":
        return <span className="badge bg-warning-subtle text-warning text-uppercase">Callback Requested</span>;
      
      case "NotInterested":
        return <span className="badge bg-secondary-subtle text-secondary text-uppercase">Not Interested</span>;
      
      case "InvalidContact":
        return <span className="badge bg-danger-subtle text-danger text-uppercase">Invalid Contact</span>;
      
      case "CallNotAnswered":
        return <span className="badge bg-warning-subtle text-warning text-uppercase">Call Not Answered</span>;
      
      case "Failed":
        return <span className="badge bg-danger-subtle text-danger text-uppercase">{status}</span>;
      
      case "InTouchThroughOtherMeans":
        return <span className="badge bg-primary-subtle text-primary text-uppercase">In Touch (Other)</span>;
      
      case "New":
        return <span className="badge bg-info-subtle text-dark text-uppercase">{status}</span>;
      
      case "Ongoing":
        return <span className="badge bg-warning-subtle text-warning text-uppercase">{status}</span>;
      
      default:
        return <span className="badge bg-secondary text-uppercase">{status}</span>;
    }
  };

  return <React.Fragment>{getStatusBadge(cell.value)}</React.Fragment>;
};

export { AppId, Name, Designation, Date, Contact, Type, Status };
